import { useEffect, useState, useRef } from "react";
// import useDebounce from "./useDebounce";
import { trackPlaceViewed, trackPageScrolled } from "@/utils/mixpanel";

export const useTrackPlaceListScroll = (places = [], disabled = false) => {
	const firstScrollRef = useRef(false);
	const [activePlace, setActivePlace] = useState(null);
	const [activePlaceIndex, setActivePlaceIndex] = useState(null);
	const [scrollOffset] = useState(0);
	// const topListOffsetDebounce = useDebounce(scrollOffset, 1000);
	const placesRef = useRef(places); // Add a ref to store the places array

	// Update the ref whenever places changes
	useEffect(() => {
		placesRef.current = places;
	}, [places]);

	const onScroll = () => {
		if (!firstScrollRef.current) {
			firstScrollRef.current = true;
			trackPageScrolled();
			return;
		}

		const placeElements = document.querySelectorAll(`[id^="place_"]`);
		for (const placeElement of placeElements) {
			const placeElementId = placeElement.id.split("_")[1];
			const offsetPosition = placeElement?.getBoundingClientRect().top;

			if (offsetPosition < 400) {
				const foundPlace = placesRef.current.find(
					(place) => place._id === placeElementId
				);
				foundPlace && setActivePlace(foundPlace);
				foundPlace &&
					setActivePlaceIndex(placesRef.current.indexOf(foundPlace));
			} else {
				break;
			}
		}
	};

	useEffect(() => {
		if (!disabled) {
			window.addEventListener("scroll", onScroll);

			return () => {
				window.removeEventListener("scroll", onScroll);
			};
		}
	}, [disabled]);

	return { activePlace, setActivePlace, scrollOffset, activePlaceIndex };
};
